// extracted by mini-css-extract-plugin
export var linkText = "_mt-0";